<form [formGroup]="propertyDetails" id="property-details" (ngSubmit)=onSubmit(propertyDetails)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container" [ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" (editQuestionChange)="editQuestionChange($event)">
			<question [qID]="'1'">
				<div class="text-lg-right text-md-center text-center">
					<h1 class="app-title-xxxlarge-blue">{{'PROPERTY_DETAILS.Q1.QUESTION'|translate}}</h1>
				</div>
		
				<div class="d-flex flex-column justify-content-md-start justify-content-center">
					<app-mat-autocomplete [data]="cities" formControlName="inWhichCity" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}" [attAriaLabel]="'PROPERTY_DETAILS.Q1.PH1'|translate"></app-mat-autocomplete>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('inWhichCity').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('inWhichCity').hasError('isNotInList') && !propertyDetails.get('inWhichCity').hasError('required') && submitted">
						{{'PROPERTY_DETAILS.Q1.NOT_IN_LIST_ERROR' | translate}}
					</label> 
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5 mt-md-0">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': propertyDetails.valid && qID=='1', 'button-primary-disabled': !(propertyDetails.valid && qID=='1')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<question [qID]="'2'">
				<div class="text-md-right text-center">
					<h1 class="app-title-xxxlarge-blue">{{"PROPERTY_DETAILS.Q2.QUESTION"|translate}}</h1>
				</div>
				<div class="row justify-content-md-start justify-content-center">
					<div class="col-lg-3 col-md-6 col-sm-12">
						<app-animated-input formControlName="propertyValue" [maxLength]="14" [type]="'tel'" placeholder="{{'PROPERTY_DETAILS.Q2.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [attAriaLabel]="'PROPERTY_DETAILS.Q2.PH1'|translate" #propertyValue></app-animated-input>
						<div class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('propertyValue').hasError('required') && submitted" role="alert">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				
				</div>
				
				<div class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('propertyValue').hasError('amountValidator75') && submitted" role="alert">
					{{'PROPERTY_DETAILS.Q2.ERROR_75' | translate }}
					{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
				</div>
				<div class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('propertyValue').hasError('amountValidator70') && submitted" role="alert">
					{{'PROPERTY_DETAILS.Q2.ERROR_70' | translate }}
					{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
				</div>
				<div class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('propertyValue').hasError('amountValidator50') && submitted" role="alert">
					{{'PROPERTY_DETAILS.Q2.ERROR_50' | translate }}
					{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
				</div>
				
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': propertyDetails.valid, 'button-primary-disabled': !(propertyDetails.valid && qID=='2')}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<question [qID]="'3'">
				<div>
					<h1 class="app-title-xxxlarge-blue text-center text-md-right">{{"PROPERTY_DETAILS.Q3.QUESTION"|translate}}</h1>
					<div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start text-center">
						<div class="">
							<app-animated-input formControlName="stadiumValue" [maxLength]="14" [type]="'tel'" placeholder="{{'PROPERTY_DETAILS.Q3.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [attAriaLabel]="'PROPERTY_DETAILS.Q3.PH1'|translate" #stadiumValue></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('stadiumValue').hasError('required') && submitted" role="alert">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</label>
						</div>
						<div class="mr-md-4 mt-2 mt-md-0">
							<app-animated-input formControlName="constructionCost" [maxLength]="14" [type]="'tel'" placeholder="{{'PROPERTY_DETAILS.Q3.PH2'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [attAriaLabel]="'PROPERTY_DETAILS.Q3.PH2'|translate"></app-animated-input>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('constructionCost').hasError('required') && submitted" role="alert">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</label>
						</div>
					</div>
					<label class="app-error form-text d-flex justify-content-center justify-content-md-start" *ngIf="propertyDetails.hasError('amountValidator75') && submitted" role="alert">
						{{'PROPERTY_DETAILS.Q2.ERROR_75' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<label class="app-error  form-text d-flex justify-content-center justify-content-md-start" *ngIf="propertyDetails.hasError('amountValidator70') && submitted" role="alert">
						{{'PROPERTY_DETAILS.Q2.ERROR_70' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<label class="app-error  form-text d-flex justify-content-center justify-content-md-start" *ngIf="propertyDetails.hasError('amountValidator50') && submitted" role="alert">
						{{'PROPERTY_DETAILS.Q2.ERROR_50' | translate }}
						{{'PROPERTY_DETAILS.Q2.ERROR_MSG' | translate }}
					</label>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': propertyDetails.valid, 'button-primary-disabled': !(propertyDetails.valid && qID=='3')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<question [qID]="'3.1'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"PROPERTY_DETAILS.Q3_1"|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center" data-toggle="buttons">
					<label class="app-label button-secondary-disabled text-center" [ngClass]="{'selected':propertyDetails.get('isYourField').value==='YES'}" tabindex="0" data-id="qID3.1a" data-fieldName="isYourField" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="isYourField" value="YES" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled text-center mr-md-3 mt-3 mt-md-0" [ngClass]="{'selected':propertyDetails.get('isYourField').value==='NO'}" tabindex="0" data-id="qID3.1b" data-fieldName="isYourField" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="isYourField" value="NO" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>

			<question [qID]="'3.2'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"PROPERTY_DETAILS.Q3_2"|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center" data-toggle="buttons">
					<label class="app-label button-secondary-disabled text-center" [ngClass]="{'selected':propertyDetails.get('isPlanToBuildOnTheField').value==='YES'}" tabindex="0" data-id="qID3.2a" data-fieldName="isPlanToBuildOnTheField" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="isPlanToBuildOnTheField" value="YES" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled text-center mr-md-3 mt-3 mt-md-0" [ngClass]="{'selected':propertyDetails.get('isPlanToBuildOnTheField').value==='NO'}" tabindex="0" data-id="qID3.2a" data-fieldName="isPlanToBuildOnTheField" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="isPlanToBuildOnTheField" value="NO" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>

			<question [qID]="'3.3'">
				<div>
					<h1 class="app-title-xxxlarge-blue text-center text-md-right">{{"PROPERTY_DETAILS.Q3_3.QUESTION"|translate}}</h1>
					<div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start text-center">
						<div class="input-wrapper">
							<app-animated-input formControlName="buildCost" [type]="'tel'" placeholder="{{'PROPERTY_DETAILS.Q3_3.PH1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [attAriaLabel]="'PROPERTY_DETAILS.Q3_3.PH1'|translate" #buildCost></app-animated-input>
							<div class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('buildCost').hasError('required') && submitted" role="alert">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
						<button type="submit" class="app-button" [ngClass]="{'button-primary': propertyDetails.valid, 'button-primary-disabled': !(propertyDetails.valid && qID=='3.3')}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<question [qID]="'4'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"PROPERTY_DETAILS.Q4"|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center" data-toggle="buttons">
					<label class="app-label button-secondary-disabled text-center" [ngClass]="{'selected':propertyDetails.get('isPropertyMortgaged').value==='YES'}" tabindex="0" data-id="qID4a" data-fieldName="isPropertyMortgaged" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="isPropertyMortgaged" value="YES" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled text-center mr-md-3 mt-3 mt-md-0" [ngClass]="{'selected':propertyDetails.get('isPropertyMortgaged').value==='NO'}" tabindex="0" data-id="qID4a" data-fieldName="isPropertyMortgaged" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="isPropertyMortgaged" value="NO" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>
			<question [qID]="'5'">
				<div class="text-md-right text-center mt-md-0 mt-5">
					<h1 class="app-title-xxxlarge-blue">{{"PROPERTY_DETAILS.Q5"|translate}}</h1>
				</div>
				<div class="btn-group-toggle d-flex flex-column flex-md-row justify-content-md-start justify-content-center" data-toggle="buttons">
					<label class="app-label button-secondary-disabled text-center" [ngClass]="{'selected':propertyDetails.get('isContractSigned').value==='YES'}" tabindex="0" data-id="qID5a" data-fieldName="isContractSigned" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="isContractSigned" value="YES" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
					<label class="app-label button-secondary-disabled text-center mr-md-3 mt-3 mt-md-0" [ngClass]="{'selected':propertyDetails.get('isContractSigned').value==='NO'}" tabindex="0" data-id="qID5a" data-fieldName="isContractSigned" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="isContractSigned" value="NO" (change)="onSubmit(propertyDetails)" click2change tabindex="-1">
					</label>
				</div>
			</question>

			<question [qID]="'6'">
				<div class="text-center mt-5 mt-md-0">
					<h1 class="app-title-xxxlarge-blue text-md-right text-center">{{"PROPERTY_DETAILS.Q6"|translate}}</h1>
					<div class="d-flex flex-column flex-md-row justify-content-md-start justify-content-center text-center">
						<div class="input-wrapper combo-width-200">
							<app-dplist-new [valueArr]='timeCombo' formControlName="timeMortgageMoney" [asyncData]="false" [atrrAriaLabel]="'PROPERTY_DETAILS.Q6'|translate" tabindex="0"></app-dplist-new>
							<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="propertyDetails.get('timeMortgageMoney').hasError('required') && submitted" role="alert">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</label>
						</div>
					</div>
					<div class="d-flex justify-content-md-end justify-content-center mt-5">
                        <button type="submit" class="app-button" [ngClass]="{'button-primary': propertyDetails.valid && qID=='6', 'button-primary-disabled': !(propertyDetails.valid && qID=='6')}">{{"COMMON.PROCEED"|translate}}</button>
                    </div>
				</div>
			</question>
		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/property-details/property-details.component.html